import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-xs md:text-sm" }
const _hoisted_2 = { class: "py-2 md:py-3" }
const _hoisted_3 = { class: "hidden p-3 md:table-cell" }
const _hoisted_4 = { class: "hidden p-3 md:table-cell" }
const _hoisted_5 = { class: "font-primary font-medium break-all" }
const _hoisted_6 = {
  class: "table-cell p-2 md:hidden",
  colpsan: "2"
}
const _hoisted_7 = { class: "font-primary font-medium break-all" }
const _hoisted_8 = { class: "py-2 text-right whitespace-nowrap md:py-3" }
const _hoisted_9 = { class: "flex flex-col items-end" }

import BankTransactionAmount from '@/components/bank-transactions/display/BankTransactionAmount.vue'
import CheckField from '@/components/fields/CheckField.vue'
import { reformatDateString } from '@/helpers/dates'

interface Props {
  /** The bank transaction to display */
  transaction: BankTransactionResource
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'UnassignedBankTransaction',
  inheritAttrs: false
},
  __name: 'UnassignedBankTransaction',
  props: {
    transaction: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
    _createElementVNode("td", _hoisted_2, [
      _createVNode(CheckField, _mergeProps({
        label: __props.transaction.name
      }, _ctx.$attrs), null, 16, ["label"])
    ]),
    _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(reformatDateString)(__props.transaction.execution_date)), 1),
    _createElementVNode("td", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(__props.transaction.name), 1)
    ]),
    _createElementVNode("td", _hoisted_6, [
      _createElementVNode("p", _hoisted_7, _toDisplayString(__props.transaction.name), 1),
      _createTextVNode(" " + _toDisplayString(_unref(reformatDateString)(__props.transaction.execution_date)), 1)
    ]),
    _createElementVNode("td", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(BankTransactionAmount, { transaction: __props.transaction }, null, 8, ["transaction"])
      ])
    ])
  ]))
}
}

})